export default __webpack_public_path__ + "static/media/play.ddfd72f3.svg";